var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCandlestickBottomNav = function SvgCandlestickBottomNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#candlestick-bottom-nav_svg__a)",
    fillRule: "evenodd",
    d: "M3.25 3.25V1h1.5v2.25h1.5v9.5h-1.5V19h-1.5v-6.25h-1.5v-9.5zm1.5 1.5h-1.5v6.5h1.5zm4.5 7.5h-1.5v5.5h1.5V19h1.5v-1.25h1.5v-5.5h-1.5V1h-1.5zm0 4h1.5v-2.5h-1.5zm6-12V1h1.5v3.25h1.5v11.5h-1.5V19h-1.5v-3.25h-1.5V4.25zm1.5 1.5h-1.5v8.5h1.5z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "candlestick-bottom-nav_svg__a",
    x1: 18.25,
    x2: 1.75,
    y1: 1.75,
    y2: 18.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#FF7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#15CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3BF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#6675FF"
  })))));
};
export { SvgCandlestickBottomNav as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjI1IDMuMjVMMy4yNSAxSDQuNzVWMy4yNUg2LjI1VjEyLjc1SDQuNzVMNC43NSAxOUgzLjI1TDMuMjUgMTIuNzVIMS43NVYzLjI1SDMuMjVaTTQuNzUgNC43NUgzLjI1VjExLjI1SDQuNzVWNC43NVpNOS4yNSAxMi4yNUg3Ljc1TDcuNzUgMTcuNzVIOS4yNUw5LjI1IDE5SDEwLjc1VjE3Ljc1SDEyLjI1VjEyLjI1SDEwLjc1TDEwLjc1IDFIOS4yNUw5LjI1IDEyLjI1Wk05LjI1IDE2LjI1SDEwLjc1VjEzLjc1SDkuMjVMOS4yNSAxNi4yNVpNMTUuMjUgNC4yNVYxSDE2Ljc1VjQuMjVIMTguMjVWMTUuNzVIMTYuNzVWMTlIMTUuMjVWMTUuNzVIMTMuNzVWNC4yNUgxNS4yNVpNMTYuNzUgNS43NUgxNS4yNVYxNC4yNUgxNi43NVY1Ljc1WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzM0NjdfNjE2MzIwMCkiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8zNDY3XzYxNjMyMDAiIHgxPSIxOC4yNSIgeTE9IjEuNzUiIHgyPSIxLjc1IiB5Mj0iMTguMjUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjEyNjMwMiIgc3RvcC1jb2xvcj0iI0ZGNzg4MCIvPgo8c3RvcCBvZmZzZXQ9IjAuMzc0NCIgc3RvcC1jb2xvcj0iIzE1Q0ZFNCIvPgo8c3RvcCBvZmZzZXQ9IjAuNjI1MTU0IiBzdG9wLWNvbG9yPSIjM0JGMkE1Ii8+CjxzdG9wIG9mZnNldD0iMC44NzYzNDgiIHN0b3AtY29sb3I9IiM2Njc1RkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";